export default "__VITE_ASSET__D7V7HppD__"